
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Sinister } from '../../../../../typescript/sinisters/sinisterInfo';
import { Appraiser } from '../../../../../typescript/sinisters/appraisers';
import LabelWithValue from '../../../../../core/components/Indicators/LabelWithValue.vue';

@Component({
  components: {
    LabelWithValue,
  },
})
export default class InspectionAppraisers extends Vue {
  @Prop({ required: true }) sinister!: Sinister;

  get appraisers(): Appraiser[] {
    return this.sinister.appraisers_list || [];
  }
}
